(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ShopSearch', ShopSearch);

  ShopSearch.$inject = ['$resource', 'API_URI'];

  function ShopSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/shops/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
